import { Auth } from "aws-amplify";
import { createSession,getLoggedInUserName,invalidateSession } from "../apis/sessionUtil";
import { apiPost } from "./apiUtils";

// export async function consigureAws() {
//   Amplify.configure({
//     aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
//     aws_user_pools_id: process.env.,
//     aws_user_pools_web_client_id: process.env.,
//   });
// }

export async function login(
  userName,
  password,
  setIsLoggedIn,
  handleLoginError
) {
  await Auth.signIn(userName, password)
    .then((user) => {
      console.dir("Login Successfull!!")
      console.dir(user)
      //console.dir(jwt_decode(user.signInUserSession.accessToken.jwtToken));
      createSession(user,userName);
      setIsLoggedIn(true);
    })
    .catch((err) => {
      handleLoginError(err.message);
    });
}
/*companName,
phoneNumber,
userName,
password,
handleSignUpSuccess,
handleSignUpFailure*/
export async function signUp(signUpObj) {
  console.log("Signpup details" + JSON.stringify(signUpObj))
  await Auth.signUp({
    username: signUpObj.userName.toLowerCase(),
    password: signUpObj.password,
    attributes: {
      "custom:companyName": signUpObj.companyName,
      "custom:phoneNumber": signUpObj.phoneno,
      "custom:firstName": signUpObj.firstName,
      "custom:lastName": signUpObj.lastName
    }
  })
    .then(() => {
      signUpObj.handleSignUpSuccess();
      
    })
    .catch((err) => {
      console.log("Sign up failed "+err.message);
      signUpObj.handleSignUpFailure(err.message)
    });

   
}

export async function confirmSignUp(
  userName,
  verificationCode,
  handleConfirmSignUpSuccess,
  handleConfirmSignUpFailure
) {
  await Auth.confirmSignUp(userName, verificationCode)
    .then(() => handleConfirmSignUpSuccess())
    .catch((err) => handleConfirmSignUpFailure(err.message));
}



export async function changePassword(password,handleSuccess,handleError){
  var userName = getLoggedInUserName();
  console.log(userName);
}

export async function logout() {
  invalidateSession();
  await Auth.signOut()
    .then((result) => console.log(result))
    .catch((err) => {
      throw err.message;
    });
}


export async function postSignUp(userName){
  const url = `${process.env.REACT_APP_API_PREFIX}/usermanagement/postSignupConfig`;
  let data = {};
  data.email = userName;
  // data.companyName = companyName;


  
  return apiPost(url,data);
 


}


export async function forgotPassword(userName){
  const url = `${process.env.REACT_APP_API_PREFIX}/usermanagement/cognito/forgotPassword`;
  let data = {}
  data.clientId = process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID;
  data.userName = userName;
  return apiPost(url,data)
}

export async function confirmForgotPassword(verificationCode, userName,password){
  const url = `${process.env.REACT_APP_API_PREFIX}/usermanagement/cognito/confirmForgotPassword`;
  let data = {}
  data.clientId = process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID;
  data.userName = userName;
  data.confirmationCode = verificationCode;
  data.password = password;
  return apiPost(url,data)
}



// Function to refresh tokens at intervals
export async function refreshTokens() {
  try {
    // Get the current session
    const currentSession = await Auth.currentSession();

    // Check if the access token is close to expiring (e.g., within 5 minutes)
    const accessTokenExpiration = new Date(currentSession.getAccessToken().getExpiration() * 1000);
    const currentTime = new Date();

    // Define a threshold for token refresh (e.g., 5 minutes before expiration)
    const tokenRefreshThreshold = 5 * 60 * 1000; // 5 minutes in milliseconds

    if (accessTokenExpiration - currentTime < tokenRefreshThreshold) {
      // Access token is about to expire, refresh it
      const refreshedSession = await Auth.currentAuthenticatedUser({ bypassCache: true });

      // You can now use the refreshed session for authenticated requests
      console.log('Refreshed Session');
    }
  } catch (error) {
    console.error('Error refreshing tokens:', error);
  }
}

// Call the refreshTokens function at regular intervals (e.g., every 15 minutes)
setInterval(refreshTokens, 15 * 60 * 1000); // 15 minutes in milliseconds

